<template>
    <input type="checkbox"
        name="report_checked"
        v-model="value"
        data-toggle="toggle"
    >
</template>

<script>
    export default {
        props: {
            args: Object
        },
        data() {
            return {
                value: this.args.bug.fixed
            }
        },
        computed: {
            $$el() {
            return jQuery(this.$el)
            }
        },
        mounted() {
            this.$$el.bootstrapToggle({
                on: 'Ja',
                off: 'Nein'
            });

            this.$$el.change((evt)=> {
                this.onSubmit(this.$$el.prop('checked'));
            })
        },
        methods: {
            onSubmit (checked) {
                var data = {
                    "fixed": checked ? 1 : 0,
                    _method: 'patch'
                }
                axios.post("/bugs/" + this.args.bug.id, data)
                .then(response => {
                    ToastSuccess("Erfolg!");
                })
                .catch(error => {
                    toastError("Ein Fehler ist aufgetreten");
                    console.log(error);
                })
            }
        }
    }
</script>
